<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Data AKUN SAKTI </strong><small>Edit Data</small>
          </CCardHeader>
          <CCardBody>
            <CForm @submit.prevent="updateUPT">
            <CRow>
              <CCol sm="6">
                <CInput
                  v-model="kode_upt"
                  label="Kode UPT"
                  placeholder="Input Kode UPT"
                />
              </CCol>
              <CCol sm="12">
                <CInput
                  v-model="nama_upt"
                  label="Nama UPT"
                  placeholder="Input Nama UPT"
                />
              </CCol>
              <CCol sm="6">
                <div class="form-group">
                <label>Status Aktif</label>
                  <select v-model="status_aktif_upt" class="form-control">
                    <option value="" disabled selected>-- Pilihan --</option>
                    <option value="1">Aktif</option>
                    <option value="0">Nonaktif</option>
                  </select>
                </div>
              </CCol>         
            </CRow>      
              <div class="form-actions">
                <CButton type="submit" color="primary" style='margin-right:15px'>Simpan</CButton>
                <CButton color="secondary" to="/upt">Batal</CButton>
              </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Error Input"
      color="danger"
      id="modalError"
    >
      <b>Error</b>! Data gagal diinput.
    </CModal>
   
  </div>    
  
</template>

<script>
import axios from 'axios';
import * as Modals from '../notifications/Modals.vue'
// import { CurrencyInput } from 'vue-currency-input'

export default {
  // components: {CurrencyInput },
  name: 'Forms',
  computed : {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2019}, (value, index) => new Date().getFullYear() - index)
    }
  },
  data () {
    return {
      kode_upt : "",
      nama_upt : "",
      status_aktif_upt : "",
      selected: [], // Must be an array reference!
      // upts: [],
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],
      jenis: ['Penyelenggaran Jalan Kabupaten/Kota'],
      subjenis: ['Pembangunan dan Peningkatan Jalan', 'Rekonstruksi / Pemeliharaan / Rehabilitasi Jalan', 'Pembangunan Jembatan / Box Culvert'],
      tahuns: ['2021','2020'],
      selectOptions: [
        'Option 1', 'Option 2', 'Option 3',
        { 
          value: 'some value', 
          label: 'Selected option'
        }
      ],
      selectedOption: 'some value',

      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom']
    }
  },
  mounted(){
  this.loadData();
  this.showUPT();
  },

  methods: {
    
    loadData: function(event){
      
      let username =window.btoa(this.$route.params.id_user);
      console.log(username);

      // axios.get(process.env.VUE_APP_BASE_URL+"pegawais")
      //   .then((response) => {
      //         // this.upts=response.data;
      //         const datas = response.data;
              
      //         this.upts = datas.map(d=>{return d['status_aktif_upt']});;
      //         console.log("datas::"+this.upts)
      //   });
    },

    updateUPT: function(event){

      const upt = { 
                          kode_upt: this.kode_upt, 
                          nama_upt: this.nama_upt,
                          status_aktif_upt: this.status_aktif_upt,
                          id_upt: this.$route.params.id_upt
                          };

      // alert(JSON.stringify(pekerjaan));
      axios.put(process.env.VUE_APP_BASE_URL+"upt/"+this.$route.params.id_upt, upt)
        .then((response) => {
            // console.log(response);
            // alert(response.data);
            if(response.status==200){
              this.$router.push('/upt');
            }
            else{
              this.modalError = true;
            }            
        })
    },
    showUPT: function(event){
    
      const upt = { 
                          kode_upt: this.kode_upt, 
                          nama_upt: this.nama_upt,
                          status_aktif_upt: this.status_aktif_upt
                          };
      // alert(JSON.stringify(pekerjaan));
      // alert(this.$route.params.id_User);

      let username =window.btoa(this.$route.params.id_user);
      console.log(username);

      axios.get(process.env.VUE_APP_BASE_URL+"upt/"+this.$route.params.id_upt)
        .then((response) => {            
              this.nama_upt=response.data.nama_upt;
              this.kode_upt=response.data.kode_upt;
              this.status_aktif_upt=response.data.status_aktif_upt;
        })
    }
  }
}
</script>